import { render, staticRenderFns } from "./asideBar.vue?vue&type=template&id=3e1a38a9&scoped=true&"
import script from "./asideBar.vue?vue&type=script&lang=js&"
export * from "./asideBar.vue?vue&type=script&lang=js&"
import style0 from "./asideBar.vue?vue&type=style&index=0&id=3e1a38a9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1a38a9",
  null
  
)

export default component.exports